module.exports = __webpack_public_path__ + "static/img/4.b6ea124.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/drilling/4.jpg
// module id = E/Us
// module chunks = 1